import type { SubsPlanType } from '@/app/types';

/** 取消原因问卷选项 */
export const CANCEL_REASON_OPTIONS = [
  { label: '价格不划算', value: '价格不划算' },
  { label: '用的不多/暂时用不到', value: '用的不多/暂时用不到' },
  { label: '效果或功能不符合预期', value: '效果或功能不符合预期' },
  { label: '支付扣款体验不好', value: '支付扣款体验不好' },
  { label: '使用其他类似产品', value: '使用其他类似产品' },
  { label: '其他原因', value: '其他原因', inputable: true },
];

/** 套餐权益文案映射（用于开屏弹窗描述） */
export const PLAN_BENEFITS_MAP: Partial<Record<SubsPlanType, { channel: string; dailyFree?: string }>> = {
  standard_v2: { channel: '快速' },
  premium_v2: { channel: '高速' },
  ultimate_v2: { channel: '极速', dailyFree: '200/天' },
};
